import FoldersCommunities from "./FoldersCommunities";

export default FoldersCommunities;
